import React from 'react'
import { HStack, Text } from '@chakra-ui/react'

const label = 'Resultados de búsqueda para:'

export type ResultTextProps = {
  searchValue?: string | null
}

export const ResultText = ({ searchValue }: ResultTextProps) => (
  <HStack display={'flex'} alignSelf={'self-start'}>
    <Text color={'#777'} fontSize={'23px'} opacity={0.5} fontWeight={'500'}>
      {label}
    </Text>
    <Text opacity={1} color={'#777'} fontSize={'23px'} fontWeight={'500'}>
      {searchValue}
    </Text>
  </HStack>
)
